<template>
  <div>
    <label v-if="title" for="">{{ title }}</label>
    <div class="selector">
      <draggable :tag="'ul'" v-model="val">
        <li v-for="v in val" :key="v.id">
          <span>
            {{ v[selectKey] }}
          </span>
          <span v-if="!disabled" @click="clearItem(v.id)"> ✕ </span>
        </li>
      </draggable>
      <div @click="open" class="background" />
      <span v-if="disabled !== true" @click="open" class="ti-angle-down"></span>
    </div>
    <list-item
      :modal="modal"
      v-model="val"
      :prefix="prefix"
      :disabled="disabled"
      :params="params"
      :pushLink="pushLink"
    />
  </div>
</template>
<script>
import draggable from "vuedraggable";
export default {
  data: () => ({
    // val: null,
  }),
  props: {
    pushLink: {
      default: "",
    },
    title: {
      default: "",
    },
    disabled: {
      default: false,
    },
    value: {
      default: "",
    },
    modal: {
      default: "",
    },
    selectKey: {
      default: "",
    },
    prefix: {
      default: "",
    },
    params: {
      default: function () {
        return {};
      },
    },
  },
  computed: {
    val: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  components: {
    "list-item": () => import("../Modals/ListItem"),
    draggable,
  },
  methods: {
    open() {
      if (this.disabled === true) {
        return false;
      }
      this.$modal.show(`${this.modal}${this.prefix}`);
    },
    clearItem(id) {
      this.val = [...this.val].filter((item) => {
        return item.id != id;
      });
    },
  },
};
</script>
